import { useState, useEffect } from 'react';
import API from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { toast } from 'sonner';
import { COUNTIES, MARKET_TABS } from '@/lib/buyersV2';

const EMPTY = { entity_name: '', sunbiz_doc_number: '', county: 'Miami-Dade', market_tab: 'Single Family', first_name: '', last_name: '', phone: '', email: '' };
const cls = 'bg-white border-gray-300';

export function AddEntityDialog({ open, onOpenChange, onCreated }) {
  const [f, setF] = useState(EMPTY);
  useEffect(() => { if (open) setF(EMPTY); }, [open]);
  const up = (k) => (e) => setF(p => ({ ...p, [k]: e.target ? e.target.value : e }));

  const save = async () => {
    if (!f.entity_name.trim()) { toast.error('Entity name is required'); return; }
    const contact = (f.first_name || f.last_name || f.phone || f.email)
      ? [{ first_name: f.first_name, last_name: f.last_name, phones: f.phone ? [{ number: f.phone, type: 'mobile' }] : [], emails: f.email ? [f.email] : [] }] : [];
    try {
      const res = await API.post('/buyers/bulk-upsert', [{ entity_name: f.entity_name, sunbiz_doc_number: f.sunbiz_doc_number, county: f.county, market_tab: f.market_tab, contacts: contact }]);
      if (res.data.updated) toast.info('A buyer with that name/doc # already existed — it was updated');
      else toast.success('Buyer created');
      onOpenChange(false); onCreated(res.data.buyer_ids?.[0]);
    } catch (e) { toast.error(e.response?.data?.detail || 'Failed to create'); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white max-w-lg" data-testid="add-entity-dialog">
        <DialogHeader><DialogTitle>Add Buyer</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2 space-y-1"><Label className="text-xs text-gray-500">Entity name *</Label><Input data-testid="entity-name-input" value={f.entity_name} onChange={up('entity_name')} className={cls} placeholder="Sunrise Homes LLC" /></div>
          <div className="space-y-1"><Label className="text-xs text-gray-500">Sunbiz Doc #</Label><Input value={f.sunbiz_doc_number} onChange={up('sunbiz_doc_number')} className={cls} /></div>
          <div className="space-y-1"><Label className="text-xs text-gray-500">County</Label>
            <Select value={f.county} onValueChange={up('county')}><SelectTrigger className={cls}><SelectValue /></SelectTrigger><SelectContent className="bg-white">{COUNTIES.map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent></Select></div>
          <div className="space-y-1"><Label className="text-xs text-gray-500">Market</Label>
            <Select value={f.market_tab} onValueChange={up('market_tab')}><SelectTrigger className={cls}><SelectValue /></SelectTrigger><SelectContent className="bg-white">{MARKET_TABS.map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent></Select></div>
          <div />
          <div className="space-y-1"><Label className="text-xs text-gray-500">Contact first name</Label><Input data-testid="entity-first-input" value={f.first_name} onChange={up('first_name')} className={cls} /></div>
          <div className="space-y-1"><Label className="text-xs text-gray-500">Last name</Label><Input value={f.last_name} onChange={up('last_name')} className={cls} /></div>
          <div className="space-y-1"><Label className="text-xs text-gray-500">Mobile</Label><Input value={f.phone} onChange={up('phone')} className={cls} /></div>
          <div className="space-y-1"><Label className="text-xs text-gray-500">Email</Label><Input value={f.email} onChange={up('email')} className={cls} /></div>
        </div>
        <Button data-testid="entity-save-btn" onClick={save} className="bg-[#0073ea] hover:bg-[#0060c2] text-white">Create Buyer</Button>
      </DialogContent>
    </Dialog>
  );
}
